// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".hover-div .btn[data-v-47317515]{opacity:0}.hover-div:hover .btn[data-v-47317515]{opacity:1}[data-v-47317515] .table .width-400{width:400px}[data-v-47317515] .table .width-50{max-width:50px}", ""]);
// Exports
module.exports = exports;
